<sh-tabs class="tab-margin">
  <sh-tab-item label="Dashboard" active></sh-tab-item>
  <sh-tab-item label="VAL" disabled></sh-tab-item>
  <sh-tab-item label="Anatomy Education" disabled></sh-tab-item>
  <sh-tab-item label="ExpertGuidance App" disabled></sh-tab-item>
  <sh-tab-item label="Technician Training" disabled></sh-tab-item>
</sh-tabs>

<div class="dashboard-container">
  <sh-grid row="3" fit-content="true">

    <!-- Row 1 -->
    <div columns="1" col-m="12" col-s="12"></div>

    <sh-card label="Number of users logged in today" card-height="450px" columns="2" col-m="4" col-s="12">
      <sh-value-indicator value="{{userStatistics?.usersLoggedInToday}}"></sh-value-indicator>
    </sh-card>

    <sh-card label="Registered Users" card-height="500px" columns="4" col-m="4" col-s="12">
      <sh-icon slot="functions" id="regUser" icon="information" button></sh-icon>
      <sh-tooltip label="Registered Users Refers to the number of new Users registered to an Application."
        target="regUser" title='Registered Users' placement="bottom"></sh-tooltip>


      <div class="margin-bottom-3">
        <sh-switch class="width-max-content">
          <sh-switch-item (click)="onFilterSelected('week')" label="Weekly" active></sh-switch-item>
          <sh-switch-item (click)="onFilterSelected('month')" label="Monthly"></sh-switch-item>
          <sh-switch-item (click)="onFilterSelected('year')" label="Yearly"></sh-switch-item>
        </sh-switch>
      </div>
      <sh-chart id="demo-bar-chart" [data]="loggedInUserStatistics" type="bar" legend></sh-chart>
    </sh-card>

    <sh-card label="Upload (GB)" card-height="500px" columns="4" col-m="4" col-s="12">
      <sh-icon slot="functions" id="upload" icon="information" button></sh-icon>
      <sh-tooltip label="Upload Refers to total file size uploaded to an Application."
        target="upload" title='Upload' placement="bottom"></sh-tooltip>

      <sh-icon slot="functions" icon="rotate-2d" button (click)="getUploadStatistics()"></sh-icon>
      <sh-chart id="demo-pie-chart" type="line" [data]="uploadStatistics" legend></sh-chart>
    </sh-card>

    <div columns="1" col-m="12" col-s="12"></div>


    <!-- Row 2 = -->
    <div columns="1" col-m="12" col-s="12"></div>

    <sh-card label="Disk Usage (GB)" card-height="450px" columns="2" col-m="4" col-s="12">
      <sh-icon slot="functions" id="diskUsage" icon="information" button></sh-icon>
      <sh-tooltip label="Disk Usage Refers to the portion of storage that is currently in use"
        target="diskUsage" title='Disk Usage' placement="bottom"></sh-tooltip>
      <sh-icon slot="functions" icon="rotate-2d" button (click)="getDiskUsage()"></sh-icon>
      <sh-value-indicator value="{{+diskUsageStatistics}}"></sh-value-indicator>
    </sh-card>

    <sh-card label="Application Response Time (ms)" card-height="500px" columns="4" col-m="4" col-s="12">
      <div class="margin-bottom-3">
        <sh-switch class="width-max-content">
          <sh-switch-item (click)="onApplicationFilterSelected('min')" label="10 Mins" active></sh-switch-item>
          <sh-switch-item (click)="onApplicationFilterSelected('hour')" label="An Hour"></sh-switch-item>
          <sh-switch-item (click)="onApplicationFilterSelected('day')" label="A Day"></sh-switch-item>
        </sh-switch>
      </div>
      <sh-icon slot="functions" id="appRes" icon="information" button></sh-icon>
      <sh-tooltip label="Application Response Time refers to the average time taken by the server to respond to all requests in the selected timeframe."
        target="appRes" title='Application Response Time' placement="bottom"></sh-tooltip>
      <sh-icon slot="functions" icon="rotate-2d" button (click)="getApplicationResponseTime()"></sh-icon>
      <sh-chart id="demo-bar-chart" [data]="applicationResponseTime" type="line" legend></sh-chart>
    </sh-card>

    <sh-card label="Download (GB)" card-height="500px" columns="4" col-m="4" col-s="12">
      <sh-icon slot="functions" id="download" icon="information" button></sh-icon>
      <sh-tooltip label="Download Refers to total file size downloaded from an Application."
        target="download" title='Download' placement="bottom"></sh-tooltip>
      <sh-icon slot="functions" icon="rotate-2d" button (click)="getDownloadStatistics()"></sh-icon>
      <sh-chart id="demo-line-chart" type="line" [data]="downloadStatistics" legend></sh-chart>
    </sh-card>

    <div columns="1" col-m="12" col-s="12"></div>
  </sh-grid>

  <!-- <sh-grid fit-content="true">
    <div columns="1" col-m="12" col-s="12"></div>

    <div class="slider-wrapper" columns="10" col-m="12" col-s="12">
      <sh-icon class="left-paddle" (click)="scrollLeft()" icon="arrow-line-left-l" button></sh-icon>
      <ul #widgetContent class="slider">
        <li class="template">
          <sh-card card-height="500px"></sh-card>
        </li>
        <li class="template">
          <sh-card card-height="500px"></sh-card>
        </li>
        <li class="template">
          <sh-card card-height="500px"></sh-card>
        </li>
        <li class="template">
          <sh-card card-height="500px"></sh-card>
        </li>
        <li class="template">
          <sh-card card-height="500px"></sh-card>
        </li>
        <li class="template">
          <sh-card card-height="500px"></sh-card>
        </li>
        <li class="template">
          <sh-card card-height="500px"></sh-card>
        </li>
        <li class="template">
          <sh-card card-height="500px"></sh-card>
        </li>
        <li class="template">
          <sh-card card-height="500px"></sh-card>
        </li>

      </ul>
      <sh-icon class="right-paddle" (click)="scrollRight()" icon="arrow-line-right-l" button></sh-icon>
    </div>

    <div columns="1" col-m="12" col-s="12"></div>
  </sh-grid> -->
</div>
